import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box, Button, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const TimesheetDropdownItem = ({ date, count, onAdd }) => {
  const { t } = useTranslation('common');
  const [showTick, setShowTick] = useState(false);
  
  const handleAddClick = () => {
    setShowTick(true);
    onAdd();
    
    // Reset to plus icon after 1.5 seconds
    setTimeout(() => {
      setShowTick(false);
    }, 1500);
  };
  
  return (
    <Box 
      sx={{
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 4px',
        height: '32px',
        width: '100%',
        position: 'relative',
        '&:hover': {
          backgroundColor: '#f5f5f5'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', width: 'calc(100% - 28px)' }}>
        <AccessTimeIcon sx={{ fontSize: '14px', color: '#666', flexShrink: 0 }} />
        <Typography sx={{ fontSize: '0.75rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {new Date(date).toLocaleDateString()} ({count} {count === 1 ? t('timesheet') : t('timesheets')})
        </Typography>
      </Box>

      {/* Position the + button on same line, aligned with dropdown arrow */}
      <IconButton
        size="small"
        onClick={handleAddClick}
        sx={{
          padding: '2px',
          minWidth: '20px',
          width: '20px',
          height: '20px',
          fontSize: '0.75rem',
          flexShrink: 0,
          position: 'absolute',
          right: '20px',
          top: '6px',
          color: showTick ? 'green' : '#2B80B6',
          '&:hover': {
            backgroundColor: 'rgba(43, 128, 182, 0.1)'
          }
        }}
      >
        {showTick ? <CheckIcon fontSize="small" /> : <AddIcon fontSize="small" />}
      </IconButton>
    </Box>
  );
};

export default TimesheetDropdownItem; 